import React from 'react';

const Footer = () => {
  return (
    <footer className="absolute left-0 bottom-0 p-4 text-center text-white">
      <div >
        
          <a
            href="https://gravatar.com/floawd"
            target="_blank"
            rel="noopener noreferrer"
            className=" ml-1 text-white-400 hover:text-blue-600 transition-colors duration-300"
          >
            Mahmud R. Farhan,
          </a>
 
        </div>
        <div className="bottom-0 left-0">
 
        <a
          href="https://github.com/mahmud-r-farhan/Typing-App-docx-web"
          target="_blank"
          rel="noopener noreferrer"
          className="  text-white-400 hover:text-blue-600 transition-colors duration-300"
        >
          GitHub
        </a>
      </div>
    </footer>
  );
};

export default Footer;
